var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiGetListProffitSearchShare } from '../../../../actions/ProffitSearchShareAction';
import { wrapDispatch } from '../../../../helpers/action';
import { getUserMode } from '../../../../helpers/auth';
import { getProffitSearchValues, isProffitSearchFreePlan, } from '../../../../helpers/profile';
import { compose } from '../../../../helpers/recompose';
import { useSlideSearchLockItem } from '../../../../helpers/use/proffit_search/common/useSlideSearchLockItem';
import { useMyPageShareHistory } from '../../../../helpers/use/proffit_search/mypage/useMyPageShareHistory';
import { useUnmountRef } from '../../../../helpers/use/useHook';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ProffitSearchRegistrationDeviceHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchRegistrationDeviceHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import SlideAddButton from '../../Common/Action/Button/SlideAddButton';
import SlideSearchRegistrationModals from '../../Common/Modal/SlideSearchRegistrationModals';
import ProffitSearchTab from './Parts/Common/ProffitSearchTab/ProffitSearchTab';
import ShareFilter from './Parts/ShareHistroy/ShareFilter/ShareFilter';
import ShareTable from './Parts/ShareHistroy/ShareTable/ShareTable';
const ShareHistoryInner = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            text: 'フォルダ',
        },
    ], []);
    const profile = useSelector((state) => state.profile);
    const auth = useSelector((state) => state.auth);
    const userMode = getUserMode(auth);
    const { formatQuery, onBlurKeyword, onClickSort, onPageChange } = useMyPageShareHistory.useEvent();
    const [loadingMap, changeLoading] = useState({});
    const [dataMap, changeData] = useState({});
    const [pageCountMap, changePageCount] = useState({});
    const key = `${formatQuery.page}_${formatQuery.searchText}`;
    const loading = !!loadingMap[key];
    const rows = dataMap[key];
    const total = pageCountMap[key];
    const onClickRow = useCallback((e) => {
        const { dataset } = e.currentTarget;
        const { share_id: shareId } = dataset;
        history.push(`/proffit_search/share_history/${shareId}`);
    }, [history]);
    const { canRegistrationTrial, plan, unReadSlideCount } = useMemo(() => getProffitSearchValues(profile), [profile]);
    const isFree = isProffitSearchFreePlan(plan);
    const { email, hideCompleteModal, hideFormModal, hidePaidModal, initialValues, isShowCompleteModal, isShowFormModal, isShowPaidModal, kanaRef, onClickLockItem, onSubmitRegistration, } = useSlideSearchLockItem.useSlideSearchLockItemModal(profile, userMode, dispatch, unmountRef);
    useEffect(() => {
        // api実行
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            changeLoading((prev) => (Object.assign(Object.assign({}, prev), { [key]: true })));
            const { payload: { list }, total: setTotal, } = yield wrapDispatch(dispatch, apiGetListProffitSearchShare({
                keyword: formatQuery.searchText,
                order: formatQuery.order,
                page: formatQuery.page,
                sort: formatQuery.sort,
            }));
            if (unmountRef.current) {
                return;
            }
            changeData((prev) => (Object.assign(Object.assign({}, prev), { [key]: list })));
            changePageCount((prev) => (Object.assign(Object.assign({}, prev), { [key]: setTotal })));
            changeLoading((prev) => (Object.assign(Object.assign({}, prev), { [key]: false })));
        }))();
    }, [
        formatQuery.page,
        formatQuery.searchText,
        formatQuery.sort,
        formatQuery.order,
        dispatch,
        changeData,
        changeLoading,
        changePageCount,
        unmountRef,
        key,
    ]);
    return (_jsxs(Layout, Object.assign({ headerType: 'proffit_search', mainClassName: 'l-main slide_search_page slide_search_mypage_share_page', sticky: _jsx(SlideAddButton, { disabled: isFree, onClickLockItem: onClickLockItem }), stickyClassName: 'slide_search_page' }, { children: [_jsxs("div", Object.assign({ className: 'l-container' }, { children: [_jsx(Breadcrumb, { lists: pans }), _jsx("div", Object.assign({ className: 'mypage_container' }, { children: _jsxs("div", Object.assign({ className: 'mypage_content' }, { children: [_jsx(ProffitSearchTab, { active: 'share_history', rightColumn: _jsx(ShareFilter, { defaultKeywordValue: formatQuery.searchText, onBlurKeyword: onBlurKeyword }), unReadReceiveCount: unReadSlideCount }), _jsx("div", Object.assign({ className: 'proffit_search_table_box' }, { children: _jsx(ShareTable, { loading: loading, onClickRow: onClickRow, onClickSort: onClickSort, order: formatQuery.order, rows: rows, searchText: formatQuery.searchText, sort: formatQuery.sort }) })), total > 0 && (_jsx("div", Object.assign({ className: 'pagination-menu proffit_search_table_pagination' }, { children: _jsx(ReactPaginate, { forcePage: formatQuery.page - 1, marginPagesDisplayed: 3, nextLabel: '>', onPageChange: onPageChange, pageCount: Math.ceil(total / 6), pageRangeDisplayed: 5, previousLabel: '<' }) })))] })) }))] })), _jsx(SlideSearchRegistrationModals, { canRegistrationTrial: canRegistrationTrial, email: email, hideCompleteModal: hideCompleteModal, hideFormModal: hideFormModal, hidePaidModal: hidePaidModal, initialValues: initialValues, isShowCompleteModal: isShowCompleteModal, isShowFormModal: isShowFormModal, isShowPaidModal: isShowPaidModal, kanaRef: kanaRef, onSubmitRegistration: onSubmitRegistration, userMode: userMode })] })));
};
const MyShareHistory = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchRegistrationDeviceHoc(), ProffitSearchTutorialHoc())(ShareHistoryInner);
export default MyShareHistory;
